import { render, staticRenderFns } from "./ColorGrid.vue?vue&type=template&id=655ea347&"
import script from "./ColorGrid.vue?vue&type=script&lang=js&"
export * from "./ColorGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports